var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshbooksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.8 5.9h17.4v25.9h-17.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.1 2.3c-7.8 0-14.1 6.3-14.1 14.1v19.3h19.3c7.8 0 14.1-6.3 14.1-14.1v-19.3zm11.4 5.9c0 2.6-2.1 4.6-4.6 4.6h-5v4h6.7v4.6h-6.6v9.6h-5.5v-24h5.4v4.3c.2-2.4 2.2-4.3 4.6-4.3h5z",
    fill: "#0075dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshbooksIcon);
export default __webpack_public_path__ + "static/media/freshbooks-icon.2c53b6d57e6252db8afb968bede6b0cf.svg";
export { ForwardRef as ReactComponent };